import { createServerFn } from "@tanstack/react-start";
import type { Lang } from "./config";

export type UiTranslationRow = {
  translation_key: string;
  sv: string;
  en: string;
  es: string;
};

/** Publika gränssnittstexter. Klienten behåller alltid de lokala texterna som reserv. */
export const getUiTranslations = createServerFn({ method: "GET" }).handler(
  async (): Promise<UiTranslationRow[]> => {
    try {
      const { odb } = await import("@/lib/orders.server");
      const { data, error } = await odb()
        .from("ui_translations")
        .select("translation_key, sv, en, es")
        .order("translation_key");
      if (error) throw error;
      return (data ?? []) as UiTranslationRow[];
    } catch (error) {
      console.error("[i18n] Could not load database translations", error);
      return [];
    }
  },
);

export function translationFor(row: UiTranslationRow, lang: Lang): string {
  return row[lang];
}